import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard-maintenance-info-panel',
    templateUrl: './dashboard-maintenance-info-panel.component.html',
    styleUrls: ['./dashboard-maintenance-info-panel.component.scss'],
    standalone: false
})
export class DashboardMaintenanceInfoPanelComponent {}
